/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionOut } from './TransactionOut';
import {
    TransactionOutFromJSON,
    TransactionOutFromJSONTyped,
    TransactionOutToJSON,
} from './TransactionOut';

/**
 * 
 * @export
 * @interface TransactionsTransactionOut
 */
export interface TransactionsTransactionOut {
    /**
     * 
     * @type {Array<TransactionOut>}
     * @memberof TransactionsTransactionOut
     */
    value?: Array<TransactionOut>;
}

/**
 * Check if a given object implements the TransactionsTransactionOut interface.
 */
export function instanceOfTransactionsTransactionOut(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TransactionsTransactionOutFromJSON(json: any): TransactionsTransactionOut {
    return TransactionsTransactionOutFromJSONTyped(json, false);
}

export function TransactionsTransactionOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionsTransactionOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : ((json['value'] as Array<any>).map(TransactionOutFromJSON)),
    };
}

export function TransactionsTransactionOutToJSON(value?: TransactionsTransactionOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value === undefined ? undefined : ((value.value as Array<any>).map(TransactionOutToJSON)),
    };
}

